import { useEffect, useState, useRef } from 'react'
import { Image as ImageICO } from 'lucide-react'
import * as styled from '../../util/styled'

const ImageRender = styled.img<{ show: boolean }>(props => [
  'w-full h-full object-cover rounded-lg',
  { 'hidden': !props.show },
])

const Loading = styled.div('w-full h-full bg-surface rounded-lg animate-pulse flex flex-col justify-center items-center text-text-disabled')
const Error = styled.div('w-full h-full bg-surface rounded-lg flex flex-col justify-center items-center text-text-disabled')
const PlaceholderImage = styled.component(ImageICO)('w-12 h-12')

type Props = {
  src: string
  alt: string
  className?: string
} & React.HTMLAttributes<HTMLImageElement>

export const ImageTile = (props: Props) => {
  const { src, alt, className, ...rest } = props
  const img = useRef<HTMLImageElement>(null)
  const [loadingState, setLoadingState] = useState<'loading' | 'loaded' | 'error'>('loading')
  useEffect(() => {
    if (props.src && img.current) {
      img.current.src = props.src
      setLoadingState('loading')
      img.current.onload = () => setLoadingState('loaded')
      img.current.onerror = () => setLoadingState('error')
    }
  }, [props.src])
  return (
    <>
      <ImageRender show={loadingState === 'loaded'} src={src} ref={img} alt={alt} {...rest} />
      {loadingState === 'loading' && <Loading><PlaceholderImage /></Loading>}
      {loadingState === 'error' && <Error><PlaceholderImage /></Error>}
    </>
  )
}